import { ReactNode } from "react";
import {
    TableCell as BaseTableCell,
    TableHead as BaseTableHead,
    TableHeader as BaseTableHeader,
} from "../shadcn";

export const TableCell = ({ children, className = "" }: { children: ReactNode, className?: string }) => (
    <BaseTableCell className={`py-2 text-gray-primary ${className || ""}`}>
        {children}
    </BaseTableCell>
);

export const TableHeader = ({ children, className = "" }: { children: ReactNode, className?: string }) => (
    <BaseTableHeader className={`bg-gray-100 ${className || ""}`}>{children}</BaseTableHeader>
);

export const TableHead = ({ children, className = "" }: { children: ReactNode, className?: string }) => (
    <BaseTableHead className={`text-sm font-semibold text-gray-primary ${className}`}>
        {children}
    </BaseTableHead>
);

export { Table, TableBody, TableRow } from "../shadcn";
